<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="640px">
             <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex v-if="!Update_Details">Add Course Pricing</v-flex>
                    <v-flex v-else>Update Course Pricing</v-flex>
                    <v-btn icon @click="CloseCourseModal"> 
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text v-if="!Update_Details">
                    <v-flex>
                        <v-flex>
                             <v-select item-value='_id' item-text='name' return-object v-model="SelectedCourse" :items="GetCourseDetailList" @change="SetCourseType" label="Select Course">
                                <template slot='selection' slot-scope='{ item }'>
                                    {{ item.Course_Title }}
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    {{ item.Course_Title }}    
                                </template>
                            </v-select>
                        </v-flex>
                        <v-layout v-for="item in CourseType" :key="item" row>
                            <v-flex style="padding-top: 20px;">{{ CourseTypeLabel(item) }}</v-flex>
                            <v-flex style="margin:0px 10px;">
                                <v-text-field :id="item+'_Actual_Price'" label='Actual Price' v-model="Pricing.Actual_Price[item]"></v-text-field>
                            </v-flex>
                            <v-flex style="margin:0px 10px;">
                                <v-text-field :id="item+'_Discounted_Price'" label='Discounted Price' v-model="Pricing.Discounted_Price[item]"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card-text>
                <v-card-text v-else>
                    <v-flex>
                        <v-flex>
                            Course Title : {{ Course_Title }}
                        </v-flex>
                        <v-flex>
                            Course Type : {{ CourseTypeLabel(Course_Type) }}
                        </v-flex>
                        <v-flex style="margin:0px 10px;">
                                <v-text-field label='Actual Price' v-model="Actual_Price"></v-text-field>
                        </v-flex>
                        <v-flex style="margin:0px 10px;">
                            <v-text-field label='Discounted Price' v-model="Discounted_Price"></v-text-field>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat v-if="!Update_Details" @click="CoursePricing">Add Course Pricing</v-btn>
                    <v-btn color="primary" flat v-else @click="UpdatePricing">Update Course Pricing</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </section>
</template>
<script>
import { CourseTypeLabel } from '../../util/courseTypes'
export default {
    props: ['dialog'],
    data(){
        return {

            Update_Details         : false,
            SelectedCourse         : {},
            CourseType             : [],
            Pricing                : {
                Actual_Price       : {},
                Discounted_Price   : {}
            },
            Actual_Price           : 0,
            Discounted_Price       : 0,
            Course_Id              : "",
            Course_Title           : "",
            Course_Type            : ""

        }
    },
    computed:{  
        GetCourseDetailList(){
            
            return this.$store.getters.GetCourseDetailsList
        }
    },
    methods:{
        CourseTypeLabel,
        CloseCourseModal(){
            this.ClearForm()
            this.$emit('close')
        },
        GetDetailstoUpdate(Pricing){
            
            this.Update_Details = true
            this.Course_Id        = Pricing['Course_Id']
            this.Course_Title     = Pricing['Course_Title']
            this.Course_Type      = Pricing['Course_Type']
            this.Actual_Price     = Pricing['Actual_Price']
            this.Discounted_Price = Pricing['Discounted_Price']

        },
        GetCourseListFromDB(){

            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`)
                        .then(response =>{
                            var newSet = new Set(response);
                            response = [...newSet];

                            this.$store.commit('SetCourseDetailList',response["data"]["response"])
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })
        },
        SetCourseType(){
            this.CourseType = this.SelectedCourse['Course_Types']
        },
        CoursePricing(){

            let Promise_Array = []
            this.CourseType.forEach(element => { Promise_Array.push(this.MapPricing(element)) })
            Promise.all(Promise_Array)
                    .then(response =>{

                        
                        return this.$http.post(`${this.$store.getters.GetProductionUrl}/pricing/addpricing`,response)
                    })
                    .then(response =>{

                        this.$store.commit('SetIndividualPricingInLoop',response["data"]["response"])
                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added Pricing","Color":"green","Close": false });
                        this.CloseCourseModal()

                    })
                    .catch(error =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
        },
        MapPricing(Pricing_Element){

            return new Promise((resolve,reject) =>{

                let Pricing_Se = {}
                Pricing_Se['Course_Id']        = this.SelectedCourse['_id']
                Pricing_Se['Course_Type']      = Pricing_Element
                Pricing_Se["Actual_Price"]     = parseInt(this.Pricing['Actual_Price'][Pricing_Element])
                Pricing_Se["Discounted_Price"] = parseInt(this.Pricing['Discounted_Price'][Pricing_Element])
                resolve(Pricing_Se)
            })
        },
        UpdatePricing(){

            let data = {}
            data['Course_Id']        = this.Course_Id
            data['Course_Type']      = this.Course_Type
            data["Actual_Price"]     = parseInt(this.Actual_Price)
            data["Discounted_Price"] = parseInt(this.Discounted_Price)
            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/pricing/updatepricing`,data)
                        .then(response =>{

                            this.$store.commit('UpdateIndividualPricing',response["data"]["response"][0])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated Pricing","Color":"green","Close": false });
                            this.CloseCourseModal()

                        })
                        .catch(error =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Updating Pricing","Color":"red","Close": false });
                        
                        })
        },
        ClearForm(){
            
            this.SelectedCourse         = {},
            this.CourseType             = [],
            this.Pricing                = {
                Actual_Price       : {},
                Discounted_Price   : {}
            }
            this.Actual_Price         = 0
            this.Discounted_Price     = 0
            this.Course_Id            = ""
            this.Course_Title         = ""
            this.Course_Type          = ""
        }
    }
}
</script>
<style scoped>

</style>
